import AboutContent from "$lib/data/generated/content/about/data.json";

import { uploads as AboutUploads } from "$lib/data/generated/uploads/about/uploads";

const content = {
	["about"]: AboutContent
};
const uploads = {
	...AboutUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (true) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
